<mat-dialog-content>
  <lemon-dialog-header> Tositteiden lataushistoria </lemon-dialog-header>

  <div style="padding-left: 3em; padding-right: 3em">
    @if (commonError()) {
      <div class="error-text">Lataushistorian lataamisen tai tositteiden lataamismerkintöjen peruuttamisen aikana tapahtui virhe. Virhe on tallennettu. Ole hyvä ja ota yhteys ylläpitoon.</div>
    }
    <table>
      <tr>
        <th>Vuosi/kk</th>
        <th>Latauspvm</th>
        <th>Lataaja</th>
        <th>Peru merkintä</th>
      </tr>
      @for (latauskerta of latauskerrat(); track latauskerta) {
        <tr>
          <td>{{ latauskerta.vuosi }}/{{ latauskerta.kuukausi }}</td>
          <td>{{ latauskerta.lataamisaika | ltimestamp | async }}</td>
          <td>{{ latauskerta.lataajanNimi }}</td>
          <td style="text-align: center">
            <app-icon-button (click)="merkitseLataamattomaksi(latauskerta)" actionId="Merkitse tositteet lataamattomaksi" [actionContext]="[latauskerta.avain]" matIcon="undo"> </app-icon-button>
          </td>
        </tr>
      }
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 3em; padding-right: 3em">
  <app-primary-button mat-dialog-close actionId="Sulje (asiakkaan tositteiden lataushistoria dialog)">Sulje</app-primary-button>
</mat-dialog-actions>
